import React, { useContext, useState } from "react";
import "./style.css";
import { Tooltip } from "antd";
import logo from "../../../Assets/Images/Logo.png";
import logoDark from "../../../Assets/icons/Sidebaricon/Logo Dark.svg";
import { useNavigate } from "react-router-dom";
import back from "../../../Assets/icons/move-right.svg";
import backDark from "../../../Assets/icons/move-right-dark.svg";
import { Button } from "antd";
import { ThemeContext } from "../../../Contexts/ThemeProvider";
import gmailLogo from "../../../Assets/Images/gmail.png";
import outlookLogo from "../../../Assets/Images/outlook.png";
import yahooLogo from "../../../Assets/Images/yahoo.webp";
import icloudLogo from "../../../Assets/Images/icloud.jpg";
import protonLogo from "../../../Assets/Images/proton.webp";
import zohoLogo from "../../../Assets/Images/zoho.png";

const ResetPassword = () => {
  const { isDarkMode } = useContext(ThemeContext);

  const navigate = useNavigate();

  const links = [
    {
      name: "Gmail",
      url: "https://mail.google.com/mail/u/0/#inbox",
      logo: gmailLogo,
    },
    {
      name: "Outlook",
      url: "https://outlook.live.com/mail/0/",
      logo: outlookLogo,
    },
    {
      name: "iCloud",
      url: "https://www.icloud.com/mail",
      logo: icloudLogo,
    },
    {
      name: "Zoho Mail",
      url: "https://mail.zoho.com/zm/",
      logo: zohoLogo,
    },
    {
      name: "Yahoo",
      url: "https://mail.yahoo.com",
      logo: yahooLogo,
    },
    {
      name: "ProtonMail",
      url: "https://mail.proton.me/u/0/inbox",
      logo: protonLogo,
    },
  ];

  return (
    <div className="reset-page">
      <div className="logo">
        <img src={isDarkMode ? logoDark : logo} alt="Company Logo" />
      </div>

      <div className="reset">
        <div className="reset-card">
          <Button
            type="text"
            icon={
              <img
                src={isDarkMode ? backDark : back}
                alt="Back"
                className="back-icon"
              />
            }
            onClick={() => navigate("/login")}
            className="back-button"
          >
            Back
          </Button>

          <div className="title">
            <div className="main">Reset Password Link Sent</div>
            <div className="sub">
              Password Reset link has been shared to your Email Address.
              <div
                style={{
                  fontSize: "0.85rem",
                  color: "#888",
                  marginTop: "4px",
                }}
              >
                Please check your Spam or Junk folder as well.
              </div>
            </div>
          </div>
          <div className="email-links-container">
            {links.map((link) => (
              <Tooltip title={`Open ${link.name}`} key={link.name}>
                <img
                  src={link.logo}
                  alt={link.name}
                  className="email-logo"
                  onClick={() => window.open(link.url, "_blank")}
                />
              </Tooltip>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
